module.exports = __webpack_public_path__ + "static/medium-garden_ceramic_repurposed-fur_found-object_freshwater-pearls-2c8c2f08685165a14f2cb623f88e868e.jpg";